/** Maps sync run phase codes to Danish labels for the admin UI. */
export const ORG_SYNC_PHASE_LABELS: Record<string, string> = {
  begin: 'Starter sync',
  keycloak_fetch_prepare: 'Forbereder Keycloak-kald',
  keycloak_fetch: 'Henter brugere fra Keycloak',
  keycloak_http_wait: 'Venter på Keycloak API (HTTP)',
  cleanup: 'Filtrerer roller / cleanup',
  load_ou_users: 'Henter eksisterende org-brugere (DB)',
  build_email_map: 'Bygger e-mail-kort (DB)',
  match_unmatched: 'Matcher Keycloak ↔ DUNA',
  create_users: 'Opretter/opdaterer brugere',
  soft_delete: 'Soft-delete af fjernede brugere',
  clear_conflicts: 'Rydder løste konflikter',
  org_complete: 'Færdig',
  skipped: 'Sprunget over',
};

export function phaseLabelDa(phase: string | null | undefined): string {
  if (!phase) {
    return '–';
  }
  return ORG_SYNC_PHASE_LABELS[phase] ?? phase;
}

export function progressDetail(row: {
  last_run_status?: string | null;
  last_run_phase?: string | null;
  last_run_last_user_index?: number | null;
  last_run_users_after_cleanup?: number | null;
  last_run_keycloak_users_count?: number | null;
  last_run_elapsed_ms?: number | null;
}): string {
  const parts: string[] = [];
  const phase = row.last_run_phase;
  if (phase) {
    parts.push(phaseLabelDa(phase));
  }
  if (phase === 'keycloak_http_wait' || phase === 'keycloak_fetch') {
    parts.push('(API-kald kan tage op til 2 min.)');
  }
  if (phase === 'create_users') {
    const idx = row.last_run_last_user_index;
    const total = row.last_run_users_after_cleanup;
    if (idx != null && total != null && total > 0) {
      parts.push(`bruger ${idx} / ${total}`);
    } else if (idx != null) {
      parts.push(`bruger #${idx}`);
    }
  }
  if (row.last_run_keycloak_users_count != null && phase !== 'create_users') {
    parts.push(`Keycloak: ${row.last_run_keycloak_users_count} brugere`);
  }
  if (row.last_run_status === 'running' && row.last_run_elapsed_ms != null) {
    parts.push(`kørt ${formatElapsed(row.last_run_elapsed_ms)}`);
  }
  return parts.join(' · ') || '–';
}

export function formatElapsed(ms: number): string {
  if (ms < 1000) {
    return `${ms} ms`;
  }
  const s = ms / 1000;
  if (s < 120) {
    return `${s.toFixed(0)} s`;
  }
  const m = Math.floor(s / 60);
  const rs = Math.round(s % 60);
  return `${m} min ${rs} s`;
}
